import styles from './NextStepCard.module.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@spotted-zebra-uk/ui-components';
import { Link } from 'react-router-dom';
import { JourneyTile } from '../CandidatePortal.helpers';

export type TNextStepCardProps = {
  tile: JourneyTile;
  stepNumber: number;
  totalSteps: number;
  link?: string;
};

/** The prominent "Your next step" card above the journey grid. */
const NextStepCard: FC<TNextStepCardProps> = ({
  tile,
  stepNumber,
  totalSteps,
  link,
}) => {
  const { t } = useTranslation();

  return (
    <section
      className={styles.card}
      aria-label={t('candidatePortal.yourNextStep')}
    >
      {tile.thumbnailUrl && (
        <img className={styles.thumbnail} src={tile.thumbnailUrl} alt="" />
      )}
      <div className={styles.content}>
        <p className={styles.eyebrow}>
          {t('candidatePortal.yourNextStep')} ·{' '}
          {t('candidatePortal.stageCount', {
            current: stepNumber,
            total: totalSteps,
          })}
        </p>
        <h2 className={styles.title}>{tile.title}</h2>
        {tile.description && (
          <p className={styles.description}>{tile.description}</p>
        )}
        {tile.estimatedTimeMinutes != null && (
          <p className={styles.estimatedTime}>
            <Icon icon="clock" />{' '}
            {t('candidatePortal.estimatedTime', {
              minutes: tile.estimatedTimeMinutes,
            })}
          </p>
        )}
        {link && (
          <Link className={styles.continueButton} to={link}>
            {t('candidatePortal.continue')} →
          </Link>
        )}
      </div>
    </section>
  );
};

export default NextStepCard;
